/* Hammam&Co conversion release: one cart write at a time. No tracking or storage. */
(function () {
  'use strict';
  if (window.hmcCommerceV2Loaded) return;
  window.hmcCommerceV2Loaded = true;
  function init(root) {
    if (!root || root.dataset.hmcReady || !window.fetch || !window.FormData) return;
    root.dataset.hmcReady = 'true';
    var locked = false;
    var errorBox = root.querySelector('[data-hmc-error]');
    var previous = new Map();
    function cartURL() {
      var url = new URL(root.dataset.cartUrl, window.location.origin);
      var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    }
    function lock() {
      locked = true; root.setAttribute('aria-busy', 'true');
      root.querySelectorAll('button, [data-hmc-change]').forEach(function (el) {
        previous.set(el, {disabled:el.disabled, aria:el.getAttribute('aria-disabled')});
        if (el.tagName === 'BUTTON') el.disabled = true;
        el.setAttribute('aria-disabled', 'true');
      });
    }
    function reset() {
      locked = false; root.removeAttribute('aria-busy');
      previous.forEach(function (state, el) {
        if (el.tagName === 'BUTTON') el.disabled = state.disabled;
        if (state.aria === null) el.removeAttribute('aria-disabled'); else el.setAttribute('aria-disabled', state.aria);
      });
      previous.clear();
    }
    async function write(url, body, jsonBody) {
      if (locked) return;
      lock(); if (errorBox) errorBox.hidden = true;
      var controller = window.AbortController ? new AbortController() : null;
      var timer = controller ? window.setTimeout(function () { controller.abort(); }, 20000) : null;
      try {
        var headers = {'Accept':'application/json'};
        if (jsonBody) headers['Content-Type'] = 'application/json';
        var options = {method:'POST', credentials:'same-origin', headers:headers, body:body};
        if (controller) options.signal = controller.signal;
        var response = await fetch(url, options);
        var data = await response.json();
        if (!response.ok || !data || (data.status && Number(data.status) >= 400)) {
          var detail = data && (data.description || data.message);
          throw new Error(typeof detail === 'string' ? detail : 'The requested cart update was not accepted.');
        }
        // A full server render refreshes line keys, discounts, totals and the custom header.
        window.location.assign(cartURL());
      } catch (error) {
        root.removeAttribute('aria-busy');
        // An interrupted or rejected add can still have changed the cart. Do not retry blindly.
        if (errorBox) {
          var text = errorBox.querySelector('[data-hmc-error-text]');
          var uncertain = error.name === 'AbortError' || error instanceof TypeError || error instanceof SyntaxError;
          text.textContent = uncertain ? 'We could not confirm the update. Refresh your cart before trying again.' : error.message + ' Refresh your cart before trying again.';
          errorBox.querySelector('a').href = cartURL();
          errorBox.hidden = false; errorBox.focus();
        }
      } finally { if (timer) window.clearTimeout(timer); }
    }
    root.addEventListener('submit', function (event) {
      var form = event.target;
      if (locked) { event.preventDefault(); return; }
      if (!form.matches('[data-hmc-add]')) return; // Native Shopify checkout stays native.
      event.preventDefault();
      if (!form.reportValidity()) return;
      var payload = new FormData(form); // Collect before controls are disabled.
      write(root.dataset.addUrl, payload, false);
    });
    root.addEventListener('click', function (event) {
      var control = event.target.closest('[data-hmc-change]');
      if (!control || !root.contains(control)) return;
      event.preventDefault();
      if (locked || control.getAttribute('aria-disabled') === 'true') return;
      var quantity = Number(control.dataset.quantity), key = control.dataset.key;
      if (!key || !Number.isSafeInteger(quantity) || quantity < 0) return;
      write(root.dataset.changeUrl, JSON.stringify({id:key, quantity:quantity}), true);
    });
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      if (root.classList.contains('hmc-cart-v2')) window.location.reload(); else reset();
    });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-hmc-commerce]')) init(scope);
    scope.querySelectorAll('[data-hmc-commerce]').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
